import styled from "styled-components";

const PluginWorksStyles = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");
  
  width: 100%;
  position: relative;
  z-index: 60;

  select {
    width: 100%;
    height: 48px;
    padding: 0 40px 0 16px;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif !important;
    font-size: 14px;
    font-weight: 500;
    color: #111827;
    background: white;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 16px center;
    outline: none;
    box-shadow: none;

    &:hover {
      border-color: #7367f0;
    }

    &:focus {
      border-color: #7367f0;
      box-shadow: 0 0 0 4px rgba(115, 103, 240, 0.1);
    }

    option {
      padding: 12px 16px;
      font-size: 14px;
      background: white;
      color: #111827;
    }
  }
`;

export default PluginWorksStyles;
